import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContent = function (props) {
    var groups = props.groups, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-v2", { ref: ref, groups: groups ? (typeof groups === 'object' ? JSON.stringify(groups) : groups) : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContent;
